import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import { blogPosts } from '../data/blogs';
import './Blogs.css';

const Blogs = () => {
  const navigate = useNavigate();
  const featuredPost = blogPosts.find(post => post.featured);
  const regularPosts = blogPosts.filter(post => !post.featured);

  return (
    <div className="blogs-page">
      {/* CINEMATIC HERO */}
      <section className="blogs-hero">
        <div className="container">
          <motion.div 
            className="blogs-hero-content text-center"
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 1 }}
          >
            <span className="premium-accent-tag">Insights & Stories</span>
            <h1 className="hero-journal-title">The <span className="gradient-text">Spice Journal</span></h1>
            <p className="hero-journal-sub">Exploring the deep-rooted culture, health benefits, and culinary secrets of Indian spices.</p>
          </motion.div>
        </div>
      </section>

      {/* FEATURED POST — MAGAZINE STYLE */}
      <section className="featured-blog">
        <div className="container">
          <motion.div 
            className="featured-post-card"
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 1.2 }}
            onClick={() => navigate(`/blog/${featuredPost.id}`)}
            style={{ cursor: 'pointer' }}
          >
            <div className="featured-img-wrap">
              <motion.img 
                src={featuredPost.img} 
                alt={featuredPost.title}
                whileHover={{ scale: 1.05 }}
                transition={{ duration: 0.8 }}
              />
            </div>
            <div className="featured-content">
              <span className="blog-cat-premium">{featuredPost.category}</span>
              <h2 className="featured-title">{featuredPost.title}</h2>
              <p className="featured-excerpt">{featuredPost.excerpt}</p>
              <div className="blog-meta-premium">
                <span>By {featuredPost.author}</span>
                <span className="dot" />
                <span>{featuredPost.date}</span>
              </div>
              <motion.button 
                className="btn-primary" 
                style={{ marginTop: '3rem' }}
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                onClick={(e) => {
                  e.stopPropagation();
                  navigate(`/blog/${featuredPost.id}`);
                }}
              >
                Read Story
              </motion.button>
            </div>
          </motion.div>
        </div>
      </section>

      {/* BLOG GRID — ASYMMETRICAL JOURNEY */}
      <section className="blog-grid-section">
        <div className="container">
          <div className="blog-grid">
            {regularPosts.map((post, i) => (
              <motion.div 
                key={post.id}
                className="blog-card"
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.8, delay: i * 0.1 }}
                onClick={() => navigate(`/blog/${post.id}`)}
                style={{ cursor: 'pointer' }}
              >
                <div className="blog-img-wrap">
                  <motion.img 
                    src={post.img} 
                    alt={post.title}
                    whileHover={{ scale: 1.1 }}
                    transition={{ duration: 0.6 }}
                  />
                  <span className="blog-cat-tag">{post.category}</span>
                </div>
                <div className="blog-info">
                  <span className="blog-date-serif">{post.date}</span>
                  <h3 className="blog-title-card">{post.title}</h3>
                  <p className="blog-excerpt-card">{post.excerpt}</p>
                  <div className="btn-read-story">
                    Read Story <span className="arrow">→</span>
                  </div>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* NEWSLETTER — BOUTIQUE BANNER */}
      <section className="blog-newsletter">
        <div className="container">
          <motion.div 
            className="newsletter-box-premium"
            initial={{ opacity: 0, scale: 0.95 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 1 }}
          >
            <div className="newsletter-text-side">
              <h2>Join the <span className="serif-italic">Journal</span></h2>
              <p>Get our latest spice stories and exclusive offers delivered to your inbox.</p>
            </div>
            <div className="newsletter-form-side">
              <div className="form-premium-wide">
                <input type="email" placeholder="Your email address" />
                <button className="btn-primary">Subscribe</button>
              </div>
            </div>
          </motion.div>
        </div>
      </section>
    </div>
  );
};

export default Blogs;

